module.exports = __webpack_public_path__ + "static/media/10.d852c1c9.jpg";